module.exports = __webpack_public_path__ + "static/bulezau-6d0c22190c731622fa0cdef252a73d91.png";